<!-- 机房组态设置 -->
<template>
    <div style="height:100%;">
        <div class="tcs-headerbox">
            <div class="headerbox-left">机房组态设置</div>
            <div class="headerbox-right">
                <el-button type="text" icon="el-icon-document" @click="handleSave">保存</el-button>
                <el-button type="text" icon="el-icon-rank" @click="handleFull">全屏查看</el-button>
                <el-button type="text" icon="el-icon-delete" @click="handleDeteleNode">删除节点</el-button>
                <el-button type="text" icon="el-icon-delete" @click="handleDeteleAll">清空</el-button>
            </div>
        </div>
       <div class="tcs-contentbox">
            <div class="tcs-toolbox">
                <p class="nodeinfo-title">设备列表 
                    <el-tooltip class="item" effect="dark" content="将设备列表的设备拖拽至中间画板区" placement="right-start">
                        <i class="el-icon-info" style="font-size:12px;vertical-align: text-top;margin: 0 0 0 5px;"></i>
                    </el-tooltip>
                 </p>
                 <p>选择线条 <span class="choseMode">托选</span></p>
                 <div style="font-size:14px;" class="tcs-line-box">
                     <el-row :gutter="5">
                        <el-col :span="12">
                            <img src="/static/images/line.png" alt="">
                            <span class="lineClick" data-type="line">直线</span>
                        </el-col>
                        <el-col :span="12">
                            <img src="/static/images/foldline_horizontal.png" alt="">
                            <span class="lineClick" data-type="foldLine-h">横向折线</span>
                        </el-col>
                        <el-col :span="12">
                            <img src="/static/images/foldline_vertical.png" alt="">
                            <span class="lineClick" data-type="foldLine-v">纵向折线</span>
                        </el-col>
                        <el-col :span="12">
                            <img src="/static/images/flexline_horizontal.png" alt="">
                            <span class="lineClick" data-type="flexLine-h">横向二次折线</span>
                        </el-col>
                        <el-col :span="12">
                            <img src="/static/images/flexline_vertical.png" alt="">
                            <span class="lineClick" data-type="flexLine-v">纵向二次折线</span>
                        </el-col>
                     </el-row>
                     
                 </div>
                 <p>制冷主机</p>
                 <ul class="toolbox-list">
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="ZJ" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/zhuji-on.png" />
                            </div>
                            <div class="meter-item-info">制冷主机#1</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="ZJ" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/zhuji-on.png" />
                            </div>
                            <div class="meter-item-info">制冷主机#2</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="LS" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/liushui.gif" />
                            </div>
                            <div class="meter-item-info">水管1</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="SG" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/svg/shuiguan_h.svg" />
                            </div>
                            <div class="meter-item-info">水管1</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="SG" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/svg/shuiguan_w.svg" />
                            </div>
                            <div class="meter-item-info">水管2</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="SG" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/svg/pipe2.svg" />
                            </div>
                            <div class="meter-item-info">水管3</div>
                        </div>
                    </li>
                </ul>
                <p>冷却设备</p>
                <ul class="toolbox-list">
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="LQT" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/lengqueta-off.png" />
                            </div>
                            <div class="meter-item-info">冷却塔</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="DD" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/diandong-off.png" />
                            </div>
                            <div class="meter-item-info">电动</div>
                        </div>
                    </li>
                </ul>
                <p>其他设备</p>
                <ul class="toolbox-list">
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="FSQ" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/fenshuiqi1.png" />
                            </div>
                            <div class="meter-item-info">分水器</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="PIPE" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/pipe-01.png" />
                            </div>
                            <div class="meter-item-info">管道</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="PIPE" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/pipe-02.png" />
                            </div>
                            <div class="meter-item-info">管道</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="PIPE" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/pipe-03.png" />
                            </div>
                            <div class="meter-item-info">管道</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="PIPE" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/pipe-04.png" />
                            </div>
                            <div class="meter-item-info">管道</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="KG" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/icon-fa.png" />
                            </div>
                            <div class="meter-item-info">冷却阀</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="SF" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/shuibeng.png" />
                            </div>
                            <div class="meter-item-info">冷冻泵</div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="KG" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/icon-fa-off.png" />
                            </div>
                            <div class="meter-item-info">冷却阀</div>
                        </div>
                    </li>
                     <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="ARROW" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/icon-arrow-top.png" />
                            </div>
                            <div class="meter-item-info">箭头</div>
                        </div>
                    </li>
                     <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="img" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/img-zj-status.png" />
                            </div>
                            <div class="meter-item-info"></div>
                        </div>
                    </li>
                     <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="img" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/img-mdg.png" />
                            </div>
                            <div class="meter-item-info"></div>
                        </div>
                    </li>
                    <li class="toolbox-item">
                        <div class="toolbox-imgs" topo-div-type="topo-node" topo-nodetype="img" draggable="true">
                            <div class="meter-item-img">
                                <img class="node-icon-style" src="/static/images/img-mdh.png" />
                            </div>
                            <div class="meter-item-info"></div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="tcs-infobox" id="nodeInfo">
                <p class="nodeinfo-title">设备参数设置</p>
                <form>
                <label for="">
                   线段之间的间隔
                </label>
                 <input type="text" name="bundleGap">
                 <br>
                <label for="">
                    线段拐角处长度
                </label>
                <input type="text" name="bundleOffset">
                <br>
                <label for="">
                    线宽
                </label>
                <input type="text" name="lineWidth">
                <br>
                <label for="">
                    控制节点与节点间的最小间距
                </label>
                <input type="text" name="offsetGap">
                <br>
                <label for="">
                    设置线段旋转的角度（弧度）
                </label>
                <input type="text" name="rotate">
                <br>
                <label for="">
                    虚线
                </label>
                <input type="text" name="dashedPattern">
                <br>
                <label for="">
                   该线段显示的文本
                </label>
                 <input type="text" name="text">
                 
                </form>
                <input type="text" name="status">
                <button id="btn_status">保存</button>
            </div>
            
            <div class="tcs-canvasbox" id="topology-body">
                <canvas class="topology-context" id="topology-canvas"></canvas>
            </div>
       </div>
    </div>
</template>

<script>
import Machine_Editor from './machineset'

export default {
    name:  'MachineSet',
    data() {
        return {
        };
    },
    mounted() {
        this.$nextTick(()=>{
                // 拓扑不存在,创建一个空白的拓扑图
            Machine_Editor.loadTopology()
            this.bindClick();
            this.domClick()
        })
    },
    methods: {
        // 重新绑定拖拽事件
        bindClick() {
            this.$nextTick(()=>{
                let canvas = document.getElementById('topology-canvas')
                    
                // 节点树中每个节点的拖放动作定义给拓扑图编辑器
                var nodes = $("[topo-div-type='topo-node']");
                
                var nodeLength = nodes.length;
                for (var i = 0; i < nodeLength; i++) {
                    var text = $(nodes[i]).find(".meter-item-info").eq(0).text();
                    Machine_Editor.drag(nodes[i], canvas, text);
                }
            })
        },
        domClick() {
            $('.lineClick').click(function() {
                let type = $(this).attr('data-type')
                Machine_Editor.stageMode = "edit"
                switch (type) {
                    case "line":
                        Machine_Editor.lineType = "line"
                        break;
                    case "foldLine-h":
                        Machine_Editor.lineType = "foldLine"
                        Machine_Editor.config.direction='horizontal'
                        break;
                    case "foldLine-v":
                        Machine_Editor.lineType = "foldLine"
                        Machine_Editor.config.direction='vertical'
                        break;
                    case "flexLine-h":
                        Machine_Editor.lineType = "flexLine"
                        Machine_Editor.config.direction='horizontal'
                        break;
                    case "flexLine-v":
                        Machine_Editor.lineType = "flexLine"
                        Machine_Editor.config.direction='vertical'
                        break;
                    default:
                        break;
                }
            })

            $('.choseMode').click(function() {
                Machine_Editor.stageMode = 'normal';
            })

            $('#nodeInfo input').change(function(){
                let key = $(this).attr("name");
                let val = $(this).val();
                if(Machine_Editor.currentNode.elementType == 'node') {
                    Machine_Editor.currentNode[key] = Number(val)*Math.PI
                }else {
                    Machine_Editor.currentLink[key] = Number(val)
                }
                // 
                
            })
            $("#btn_status").click(function(){
                let val = $("#nodeInfo [name=status]").val()
               if(Machine_Editor.currentNode.elementType == 'node') {
                    Machine_Editor.currentNode.nodeParams = {
                        status: val
                    }
                }else {
                     Machine_Editor.currentLink.linkParams = {
                        status: val
                    }
                }
               
            })
        },
        // 左侧工具栏
        changeContent(key) {
            this[key]= !this[key];
        },
        // 全屏查看
        handleFull() {
            Machine_Editor.utils.showInFullScreen(Machine_Editor.stage.canvas,'RequestFullScreen')
        },
        // 保存
        handleSave() {
            Machine_Editor.saveTopology(true, (jsonData)=>{
                // console.log(jsonData);
            })
        },
        // 删除节点
        handleDeteleNode() {
            Machine_Editor.utils.deleteSelectedNodes()
        },
        // 清空
        handleDeteleAll() {
            Machine_Editor.utils.clearTopology()
        },
    }
}

</script>
<style lang='less' scoped>
    .tcs-box{
        height: calc(100% - 60px);
        padding: 0;
        .tcs-headerbox{
            width: 100%;
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid rgb(203, 211, 224);
            background-color: rgb(246, 247, 251);
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            justify-content: space-between;
            .headerbox-left{
                width: 200px;
                text-align: center;
                font-size: 20px;
            }
            .headerbox-right{
                margin-right: 20px;
                button{
                    font-size: 14px;
                    margin-right: 10px;
                }
            }
        }
        .tcs-contentbox{
            overflow: hidden;
            height: calc(100% - 60px);
            .tcs-toolbox{
                float: left;
                width: 300px;
                height: 100%;
                border-right: 1px solid #ccc;
                background-color: rgb(246, 247, 251);
                overflow-y: auto;
                .toolbox-chose_build{
                    margin: 10px;
                }
                .toolbox-item{
                    &:nth-child(2n-1){
                        background-color: #e2f0ff;
                    }
                    .toolbox-imgs{
                        display: flex;
                        display: -webkit-flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        padding:5px 10px;
                        .meter-item-img{
                            display: inline-block;
                            text-align: center;
                            font-size: 0;
                            vertical-align: middle;
                            margin-right: 5px;
                        }
                        .meter-item-info{
                            flex: 1;
                            vertical-align: middle;
                            text-align: left;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            cursor: pointer;
                            display: inline-block;
                            font-size: 14px;
                            line-height: 32px;
                            &:hover{
                                color: @primary-color;
                            }
                        }
                    }
                }
            }
            .tcs-infobox{
                float: right;
                width: 200px;
                height: 100%;
                border-left: 1px solid #ccc;
                background-color: rgb(246, 247, 251);
                .nodeinfo-item{
                    display: none;
                    font-size: 14px;
                    color: #666;
                    margin:0 10px;
                    margin-bottom: 10px;
                    span{
                        display: block;
                        line-height: 30px;
                    }
                }
            }
            .tcs-canvasbox{
                margin: 0 200px 0 300px;
                padding: 15px;
                background-color: rgb(226, 229, 236);
                height: 100%;
            }
            .nodeinfo-title{
                height: 42px;
                line-height: 42px;
                color: #333;
                background-color: #f2f2f2;
                font-size: 16px;
                font-weight: 400;
                margin-bottom: 20px;
                text-align: center;
            }
        }
    }

    .tcs-line-box{
        text-align: center;
        img{
            width: 30px;
            height: 30px;
            display: block;
            margin: 0 auto;
        }
    }

</style>